<app-breadcrumb [master]="'Wyniki konkursów'" [parentName]="'Pola dodatkowe'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <mat-form-field class="list-filter">
      <mat-label>Nazwa pola</mat-label>
      <input matInput placeholder="Nazwa pola" name="contains$fieldName" [(ngModel)]="initialFilters.contains$fieldName">
    </mat-form-field>

    <app-dict class="list-filter"
              [multiple]="false" [dictType]="'field_type'"
              [label]="'Typ pola'"
              [(ngModel)]="initialFilters.fieldType" name="fieldType"
    ></app-dict>

    <mat-form-field class="list-filter">
      <mat-label>Aktywne</mat-label>
      <mat-select [(ngModel)]="initialFilters.active" name="active">
        <mat-option [value]="undefined">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div>
      <button *ngIf="(userPermissions | async).marketing.write"  (click)="addAdditionalField()" mat-stroked-button color="primary">
        <mat-icon>add</mat-icon> <span> Dodaj </span>
      </button>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
<!--      <button *ngIf="(userPermissions | async).note.limited_read" (click)="downloadReport()" [disabled]="!(userPermissions | async).note.limited_read"-->
<!--              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>-->
<!--      </button>-->
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="fieldName">
      <th mat-header-cell *matHeaderCellDef> Nazwa pola</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a class="default-link" [routerLink]="['/wyniki-konkursow/pola-dodatkowe/szczegoly', element.uuid]">
            {{ element?.fieldName}}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="fieldType">
      <th mat-header-cell *matHeaderCellDef> Typ pola </th>
      <td mat-cell *matCellDef="let element">
        {{element?.fieldType?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Aktywne </th>
      <td mat-cell *matCellDef="let element">
        {{element.active ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
